import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

interface DeleteLicenseInput {
  clientId: string;
  licenseId: string;
}

/** Mutation for `DELETE /v1/clients/{clientId}/licenses/{licenseId}` (Admin only). */
export function useDeleteLicenseMutation(): UseMutationResult<void, Error, DeleteLicenseInput> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, licenseId }: DeleteLicenseInput) => {
      if (!api) throw new Error('useDeleteLicenseMutation: api client unavailable');
      return api.delete<void>(`/v1/clients/${clientId}/licenses/${licenseId}`);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['licenses', clientId] });
    },
  });
}
